export default{
  "Mute Video": "靜音影片",
  "HitPaw Online Mute Video": "HitPaw 線上影片靜音",
  "Fast and easy to remove sound from your video online": "線上快速輕鬆刪除影片聲音",
  "Muting": "靜音中",
  "Mute Failed": "靜音失敗",
  "Mute New": "靜音新的（檔案）"
};